import { useNavigate, useParams } from 'react-router-dom';

const useCampaignNavigate = () => {
  const { teamId, campaignId } = useParams();
  const navigate = useNavigate();

  const getCampaignBasePath = (): string => {
    let basePath = '';

    if (teamId) {
      basePath = `/${teamId}/campaign/`;
    } else {
      basePath = '/campaign/';
    }

    if (campaignId) {
      return `${basePath}${campaignId}/`;
    }

    return basePath;
  };

  const getCampaignPathFor = (path: string): string => {
    const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    const basePath = getCampaignBasePath();
    return `${basePath}${normalizedPath}`;
  };

  const navigateToCampaign = (path: string): void => {
    const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    const fullPath = getCampaignPathFor(normalizedPath);
    navigate(fullPath);
  };

  return { getCampaignBasePath, getCampaignPathFor, navigateToCampaign };
};

export default useCampaignNavigate;
